import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/use-auth';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/Card';

export function Login() {
  const { status, errorMessage, signIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'signed-in') navigate('/', { replace: true });
  }, [status, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/30 px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1 text-center">
          <CardTitle className="text-2xl text-primary">X5 Admin</CardTitle>
          <CardDescription>Sign in with your XiltriX Google account.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button className="w-full" size="lg" onClick={() => void signIn()}>
            Continue with Google
          </Button>
          {status === 'unauthorized' && errorMessage && (
            <p className="text-sm text-destructive text-center">{errorMessage}</p>
          )}
          <p className="text-xs text-muted-foreground text-center">
            Access is restricted to authorized XiltriX staff. Contact an administrator if you need
            access.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
